import { useCallback } from 'react';

import { PrioritizeGoalCallback } from '../types';
import { usePrioritizeGoalOnBoardMutation } from './mutation/usePrioritizeGoalOnBoard';
import { useOpenPrioritizedGoalsSettingModal } from './useOpenPrioritizedGoalsSettingModal';
import { usePrioritizedGoalsLimitReached } from './usePrioritizedGoalsLimitReached';

export const usePrioritizeToggleOnBoard = () => {
  const isPrioritizedGoalsLimitReached = usePrioritizedGoalsLimitReached();
  const prioritizeOnBoard = usePrioritizeGoalOnBoardMutation();
  const openPrioritizedGoalsModal = useOpenPrioritizedGoalsSettingModal();

  return useCallback<PrioritizeGoalCallback>(
    (goalId, isPrioritized, columnId) => {
      if (isPrioritizedGoalsLimitReached && !isPrioritized) {
        openPrioritizedGoalsModal();
        return;
      }

      prioritizeOnBoard.mutate({
        goalId,
        isPrioritized,
        columnId: columnId!,
      });
    },
    [
      isPrioritizedGoalsLimitReached,
      openPrioritizedGoalsModal,
      prioritizeOnBoard,
    ]
  );
};
